import axios from '../../axios/axios';

const ClientOnExcursionService = {

  getAllExcursionsByClientId: (id, page = 0, size = 5, sort = "createdAt", direction = "desc") => {
    return axios.get(`/client-on-excursions/client/details/${id}?page=${page}&size=${size}&sort=${sort}&direction=${direction}`);
  },

  exportExcursionHistory: (clientId) => {
    return axios.get(`/client-on-excursions/client/export/${clientId}`, {
      responseType: 'blob'
    });
  },

  getClientOnExcursionById: (id) => {
    return axios.get(`/client-on-excursions/${id}`)
  },

  getAllDetailsByExcursionId: (id) => {
    return axios.get(`/client-on-excursions/excursion/details/${id}`)
  },

  exportExcursionDetails: (id) => {
    return axios.get(`/client-on-excursions/excursion/details/export/${id}`, {
      responseType: 'blob'
    });
  },

  addClientOnExcursion: (client, excursion, discount, travelingDocument, startingPoint, note, points, confirmedReservation, extraExpenses, seatNumber, anotherAgency) => {
    const newClientOnExcursion = {
      client: client,
      excursion: excursion,
      discount: discount,
      travelingDocument: travelingDocument,
      startingPoint: startingPoint,
      note: note,
      points: points,
      confirmedReservation: confirmedReservation,
      extraExpenses: extraExpenses,
      seatNumber: seatNumber,
      anotherAgency: anotherAgency
    }
    return axios.post("/client-on-excursions/add", newClientOnExcursion, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },

  updateExcursionDetails: (idExcursion, startingPoint, note, travelingDocument, confirmedReservation, seatNumber) =>{
    const newExcursionDetails = {
      startingPoint: startingPoint,
      note: note,
      travelingDocument: travelingDocument,
      confirmedReservation: confirmedReservation,
      seatNumber: seatNumber
    }
    return axios.post(`/client-on-excursions/excursion/update/${idExcursion}`, newExcursionDetails, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },

  updateExcursionHistory: (idClient, discount, extraExpenses) =>{
    const newExcursionHistory = {
      discount: discount,
      extraExpenses: extraExpenses
    }
    return axios.post(`/client-on-excursions/client/update/${idClient}`, newExcursionHistory, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },

  updateClientOnExcursionPaymentDetails: (idClient, discount, extraExpenses, startingPoint, travelingDocument, note, seatNumber, confirmedReservation) => {
    const newExcursionHistory = {
      discount: discount,
      // pointsUsed: pointsUsed,
      extraExpenses: extraExpenses,
      startingPoint: startingPoint,
      travelingDocument: travelingDocument,
      note: note,
      seatNumber: seatNumber,
      confirmedReservation: confirmedReservation
    }
    return axios.post(`/client-on-excursions/client/payment/update/${idClient}`, newExcursionHistory, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  },

  deleteClientOnExcursion: (id) => {
    return axios.delete(`/client-on-excursions/delete/${id}`)
  },

  fullExport: () => {
    return axios.get("/client-on-excursions/fullExport", {
      responseType: 'blob'
    })
  }
}
export default ClientOnExcursionService;